<!-- @format -->

<template>
  <div>
    <img :src="imgUrl" :style="cusStyle" />
  </div>
</template>
<script>
export default {
  name: "ImageView",
  props: {
    value: {
      default: "",
    },
    isloacle: {
      default: false,
    },
    cusStyle: {
      default: "width: 100%; height: 100%;",
    },
  },
  data() {
    return {
      // imgUrl: "",
    };
  },
  computed: {
    imgUrl() {
      if (
        this.value.indexOf("http") == -1 &&
        this.value.indexOf("https") == -1
      ) {
        return process.env.VUE_APP_IMG_API + this.value;
      } else {
        return this.value;
      }
    },
  },
  created() {
    // this.imgUrl = process.env.VUE_APP_IMG_API + this.value;
    // this.demo();
  },
  methods: {
    demo() {
      // console.log(this.imgUrl, "0000000");
    },
  },
};
</script>
<style>
.view-btn {
  padding: 0 !important;
}
</style>
